/**
 * 精灵图互动宠物 - 类型定义与常量配置
 */

// 宠物动画状态
export type PetAnimationState =
  | 'idle'
  | 'happy'
  | 'excited'
  | 'sleepy'
  | 'working'
  | 'angry'
  | 'dragging'

// 交互事件类型
export type PetEvent =
  | 'CLICK'
  | 'DOUBLE_CLICK'
  | 'RAPID_CLICK'
  | 'IDLE_TIMEOUT'
  | 'HOVER'
  | 'DRAG_START'
  | 'DRAG_END'
  | 'ANIMATION_END'

// 精灵图配置
export interface SpriteConfig {
  src: string
  cols: number
  rows: number
  frameWidth: number
  frameHeight: number
  bgTolerance: number
}

// 默认精灵图配置
export const DEFAULT_SPRITE_CONFIG: SpriteConfig = {
  src: '/sprite.jpg',
  cols: 8,
  rows: 7,
  frameWidth: 128,
  frameHeight: 128,
  bgTolerance: 60,
}

// 动画状态 → 精灵图行号映射
export const ANIMATION_ROW_MAP: Record<PetAnimationState, number> = {
  idle: 0,
  happy: 1,
  excited: 2,
  sleepy: 3,
  working: 4,
  angry: 5,
  dragging: 6,
}

// 各状态动画速度（毫秒/帧）
export const ANIMATION_SPEED: Record<PetAnimationState, number> = {
  idle: 150,
  happy: 120,
  excited: 100,
  sleepy: 200,
  working: 130,
  angry: 90,
  dragging: 140,
}

// 各状态播放次数：'infinite' 表示持续循环，数字表示有限次数
export const ANIMATION_LOOPS: Record<PetAnimationState, number | 'infinite'> = {
  idle: 'infinite',
  happy: 2,
  excited: 2,
  sleepy: 'infinite',
  working: 3,
  angry: 2,
  dragging: 'infinite',
}

// 宠物显示尺寸（px）
export const DISPLAY_SIZE = 96

// 无操作超时时间（ms）
export const IDLE_TIMEOUT = 60000

// 快速点击检测配置
export const RAPID_CLICK_COUNT = 5
export const RAPID_CLICK_WINDOW = 800

// localStorage 键名
export const POSITION_STORAGE_KEY = 'voc-pet-position'

// 精灵图记录（存储在 IndexedDB 中）
export interface SpriteRecord {
  id: string          // crypto.randomUUID()
  name: string        // 用户可识别名称
  dataUrl: string     // 完整精灵图 DataURL
  thumbnail: string   // 80×80 首帧缩略图 DataURL (JPEG 0.8)
  timestamp: number   // 创建时间戳
}

// IndexedDB 配置
export const DB_NAME = 'voc-pet-db'
export const DB_STORE_NAME = 'sprites'           // v1 旧 store（迁移用）
export const DB_VERSION = 2                       // 从 1 升级到 2
export const CUSTOM_SPRITE_KEY = 'custom-sprite'  // v1 旧键名（迁移用）
export const SPRITES_V2_STORE_NAME = 'sprites-v2' // v2 新 object store
export const ACTIVE_SPRITE_KEY = 'voc-pet-active-sprite' // localStorage 键
export const MAX_SPRITES = 20                     // 最大保存数
export const THUMBNAIL_SIZE = 80                  // 缩略图尺寸 px
export const DEFAULT_SPRITE_ID = '__default__'    // 默认精灵图虚拟 ID
export const PET_ENABLED_KEY = 'voc-pet-enabled'  // 精灵宠物开关 localStorage 键
